<template>
    <component
        :is="display"
        v-bind="props"
    />
    <Meta 
        :title="'Resources | ' + manufacturer?.name" 
        :jsonLdBreadcrumbs="crumbs" 
        :description="'View resources and documentation for ' + manufacturer?.name + ' products.'" 
    />
</template>

<script setup>
import { computed, markRaw } from "vue";
import { useUser } from "@/Composables";
import { Meta } from "@/Components";
import MarketingShow from "../../../Themes/Marketing/Pages/Catalog/Resources/Show.vue";
import SourcingShow from "../../../Themes/Sourcing/Pages/Catalog/Resources/Show.vue";

const { settings } = useUser();
const props = defineProps([
    "resources", 
    "manufacturer", 
    "crumbs", 
    "manufacturers",
    "series",
]);

const display = computed(() =>
    settings.value.is_sourcing_mode
        ? markRaw(SourcingShow)
        : markRaw(MarketingShow)
);
</script>
